import { useEffect, useState } from 'react';
import client from '../api/client';
import Layout from '../components/Layout';
import { useAuth } from '../context/AuthContext';
import { printLocationLabels } from '../qrLabels';
import './Locations.css';

export default function Locations() {
  const { org } = useAuth();
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ name: '', location_type: 'lane' });
  const [error, setError] = useState('');

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      const res = await client.get('/locations');
      setLocations(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await client.post('/locations', form);
      setShowModal(false);
      setForm({ name: '', location_type: 'lane' });
      loadData();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to create location');
    }
  };

  const toggleActive = async (id, is_active) => {
    try {
      await client.put(`/locations/${id}`, { is_active: !is_active });
      loadData();
    } catch (err) {
      console.error(err);
    }
  };

  const deleteLocation = async (id) => {
    if (!window.confirm('Delete this location?')) return;
    try {
      await client.delete(`/locations/${id}`);
      loadData();
    } catch (err) {
      console.error(err);
    }
  };

  if (loading) return <Layout><div style={{color:'#6b7280', padding:'20px'}}>Loading...</div></Layout>;

  return (
    <Layout>
      <div className="loc-header">
        <h1>Locations</h1>
        <div style={{display:'flex', gap:'10px'}}>
          <button className="loc-btn-cancel" onClick={() => locations.length && printLocationLabels(locations.filter(l => l.is_active), org?.slug)} title="Print QR tags for all active locations">Print QR Tags</button>
          <button className="loc-btn-new" onClick={() => setShowModal(true)}>+ New Location</button>
        </div>
      </div>

      <div className="loc-table-wrap">
        <table className="loc-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {locations.length === 0 && (
              <tr>
                <td colSpan="4" className="loc-empty">No locations yet. Add your first location.</td>
              </tr>
            )}
            {locations.map(loc => (
                <tr key={loc.id} className={loc.is_active ? '' : 'inactive'}>
                <td className="loc-name">{loc.name}</td>
                <td className="loc-type">{loc.location_type}</td>
                <td>
                  <div
                    className={loc.is_active ? 'loc-status active' : 'loc-status inactive'}
                    onClick={() => toggleActive(loc.id, loc.is_active)}
                    title="Click to toggle"
                  >
                    {loc.is_active ? 'Active' : 'Inactive'}
                  </div>
                </td>
                <td>
                  <button className="loc-btn-delete" style={{marginRight:'8px', color:'#8b96a5'}} title="Print QR tag" onClick={() => printLocationLabels([loc], org?.slug)}>QR</button>
                  <button className="loc-btn-delete" onClick={() => deleteLocation(loc.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="loc-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="loc-modal" onClick={e => e.stopPropagation()}>
            <h2>New Location</h2>
            {error && <div className="loc-modal-error">{error}</div>}
            <form onSubmit={handleSubmit}>
              <input
                placeholder="Location Name *"
                value={form.name}
                onChange={e => setForm({...form, name: e.target.value})}
                required
              />
              <input
                placeholder="Type (e.g. lane, bay, shelf, station)"
                value={form.location_type}
                onChange={e => setForm({...form, location_type: e.target.value})}
              />
              <div className="loc-modal-actions">
                <button type="button" className="loc-btn-cancel" onClick={() => setShowModal(false)}>Cancel</button>
                <button type="submit" className="loc-btn-new">Add Location</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </Layout>
  );
}